import { createSelector } from 'reselect';

export const uploadFileProgressSelector = (state: ReduxState) => state.app.uploadFileProgress;

export const isUploadFileProgressSelector = createSelector(
  uploadFileProgressSelector,
  (progress) => typeof progress === 'number',
)
